import { SVGProps } from 'react';

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path d='M6 7.44281L1.13807 12.3047C0.877722 12.5651 0.455612 12.5651 0.195262 12.3047C-0.0650874 12.0444 -0.0650874 11.6223 0.195262 11.3619L5.05719 6.5L0.195262 1.63807C-0.0650874 1.37772 -0.0650874 0.955612 0.195262 0.695262C0.455612 0.434913 0.877722 0.434913 1.13807 0.695262L6 5.55719L10.8619 0.695262C11.1223 0.434913 11.5444 0.434913 11.8047 0.695262C12.0651 0.955612 12.0651 1.37772 11.8047 1.63807L6.94281 6.5L11.8047 11.3619C12.0651 11.6223 12.0651 12.0444 11.8047 12.3047C11.5444 12.5651 11.1223 12.5651 10.8619 12.3047L6 7.44281Z' />
  </svg>
);
